import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { getPixelCodeSnippets } from "~/components/instructions/pixel-instructions";
import { useFeatureFlag } from "~/instrumentation/feature-flags";
import { trpc } from "~/lib/trpc";
import { SettingsTitle } from "~/routes/(app)/settings/-components/settings-title";
import { BookmarkletGuide } from "~/routes/(app)/settings/guides/-guides/bookmarklet-guide";
import { MoreHelp } from "~/routes/(app)/settings/guides/-guides/more-help";
import { PixelGuide } from "~/routes/(app)/settings/guides/-guides/pixel-guide";

export const Route = createFileRoute("/(app)/settings/guides/")({
  component: RouteComponent,
  validateSearch: z.object({
    guide: z.enum(["bookmarklet", "pixel"]).optional(),
  }),
  loader: async ({ context }) => {
    const scriptContent = await context.queryClient.ensureQueryData(
      trpc.installation.getInstallationScript.queryOptions(),
    );

    const { scriptContentHtml, exampleContentHtml } =
      await getPixelCodeSnippets(scriptContent);

    return {
      pixel: {
        scriptContent,
        scriptContentHtml,
        exampleContentHtml,
      },
      crumb: {
        label: "Installation",
        options: [],
        id: "installation",
      },
    };
  },
});

function RouteComponent() {
  const isStudioEnabled = useFeatureFlag("studio");

  return (
    <div className="space-y-4 w-full">
      <SettingsTitle>Guides</SettingsTitle>

      <div className="space-y-6 w-full text-sm">
        <ul className="space-y-4">
          <PixelGuide />
          {isStudioEnabled && <BookmarkletGuide />}
          <MoreHelp />
        </ul>
      </div>
    </div>
  );
}
